import request from '@/utils/request'

// 红果短剧列表 name string 可选、page integer 必需、page_size integer 必需
export function hongguoList(params = {}) {
  return request({
    url: '/hongguo/playlet/index',
    method: 'get',
    params
  })
}

// 添加红果短剧
// Query 参数
// name string 必需
// book_id string 可选
// limit_date string 截止时间
export function addPlaylet(data = {}) {
  return request({
    url: '/hongguo/playlet/add',
    method: 'post',
    data
  })
}
// 修改红果短剧
// Query 参数
// id integer 必需
// name string 必需
// book_id string 可选
// limit_date string 截止时间

export function updatePlaylet(data = {}) {
  return request({
    url: '/hongguo/playlet/update',
    method: 'post',
    data
  })
}
// 删除红果短剧 请求体 id integer
export function delPlaylet(data = {}) {
  return request({
    url: '/hongguo/playlet/destroy',
    method: 'post',
    data
  })
}
